module.exports = "//public.getcloudapp.com/packs/media/images/team-3-6d6bfb70189928ba59855dd46a3c44c7.jpg";